/* Cloud Theory - storefront behaviour.
   One file, no dependencies. Every handler is delegated off document so it keeps
   working for markup that arrives later (cart re-renders, search results). */
(function () {
  'use strict';

  var routes = (window.CT && window.CT.routes) || {};
  var moneyFormat = (window.CT && window.CT.moneyFormat) || '${{amount}}';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    // Shopify money formats use {{amount}} and friends; the common ones are enough here.
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  /* ---- header: shop dropdown ------------------------------------------- */
  function closeShop() {
    var m = $('#shopmenu');
    if (!m) return;
    m.setAttribute('data-open', 'false');
    var b = $('.shopmenu__btn', m);
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.shopmenu__btn');
    var menu = $('#shopmenu');
    if (btn && menu) {
      e.preventDefault();
      var open = menu.getAttribute('data-open') === 'true';
      menu.setAttribute('data-open', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }
    if (menu && !(e.target.closest && e.target.closest('#shopmenu'))) closeShop();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeShop();
    closeSearch();
  });

  /* ---- header: mobile nav ---------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#burger');
    if (!b) return;
    var nav = $('#mobnav');
    if (!nav) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    nav.setAttribute('data-open', open ? 'false' : 'true');
  });

  /* ---- header: search -------------------------------------------------- */
  var searchTimer = null;

  function closeSearch() {
    var panel = $('#srch');
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    var b = $('#srch-btn');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function renderResults(products, term) {
    var box = $('#srch-res');
    if (!box) return;
    if (!term) { box.innerHTML = ''; return; }
    if (!products.length) {
      box.innerHTML = '<li class="srch__none">No products match &ldquo;' + term.replace(/</g, '&lt;') + '&rdquo;.</li>';
      return;
    }
    box.innerHTML = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      return '<li><a href="' + p.url + '">' +
        (img ? '<img src="' + img + '&width=120" alt="" loading="lazy">' : '<span class="srch__ph"></span>') +
        '<span class="srch__t">' + p.title + '</span>' +
        '<span class="srch__p">' + (p.price != null ? money(p.price) : '') + '</span>' +
        '</a></li>';
    }).join('');
  }

  function runSearch(term) {
    if (!term) { renderResults([], ''); return; }
    var url = (routes.predictive || '/search/suggest') +
      '?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=6&section_id=&resources[options][unavailable_products]=last';
    fetch(url + '&', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(items, term);
      })
      .catch(function () { renderResults([], ''); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#srch-btn')) {
      var panel = $('#srch');
      if (!panel) return;
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      $('#srch-btn').setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) { var i = $('#srch-q'); if (i) i.focus(); }
      return;
    }
    if (e.target.closest && e.target.closest('#srch-x')) closeSearch();
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('#srch-q')) return;
    var term = e.target.value.trim();
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { runSearch(term); }, 180);
  });

  /* ---- quantity steppers ----------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.qty__b');
    if (!b) return;
    var box = b.closest('.pdp__qty');
    if (!box) return;
    var out = $('.qty__n', box);
    var field = $('input[name="quantity"]', box);
    var n = parseInt(out.textContent, 10) || 1;
    n = Math.min(99, Math.max(1, n + (parseInt(b.getAttribute('data-q'), 10) || 0)));
    out.textContent = n;
    if (field) field.value = n;
    var minus = $('.qty__b[data-q="-1"]', box);
    if (minus) minus.disabled = n <= 1;
  });

  /* ---- product gallery -------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.thumb');
    if (!t) return;
    var gal = t.closest('.pdp__gal');
    if (!gal) return;
    var main = $('.pdp__media img', gal);
    var src = t.getAttribute('data-src');
    if (main && src) {
      main.src = src;
      var srcset = t.getAttribute('data-srcset');
      if (srcset) main.srcset = srcset; else main.removeAttribute('srcset');
    }
    $$('.thumb', gal).forEach(function (o) { o.removeAttribute('aria-current'); });
    t.setAttribute('aria-current', 'true');
  });

  /* ---- cart ------------------------------------------------------------- */
  function paintBadge(count) {
    var b = $('#cart-badge');
    if (!b) return;
    b.textContent = count;
    b.hidden = count === 0;
  }

  function addToCart(id, quantity) {
    return fetch(routes.cart_add || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      paintBadge(cart.item_count);
      return cart;
    });
  }

  function flash(el, text, ms) {
    var target = el.querySelector('[data-lbl]') || el;
    if (target.dataset.busy === '1') return;
    var original = target.textContent;
    target.dataset.busy = '1';
    target.textContent = text;
    setTimeout(function () { target.textContent = original; delete target.dataset.busy; }, ms || 1400);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-add]');
    if (!btn) return;
    var id = btn.getAttribute('data-add');
    if (!id) return;
    e.preventDefault();
    var box = btn.closest('.pdp__info');
    var qtyOut = box && $('.qty__n', box);
    var qty = qtyOut ? (parseInt(qtyOut.textContent, 10) || 1) : 1;
    btn.disabled = true;
    addToCart(id, qty)
      .then(function () {
        flash(btn, 'Added');
        if (document.body.classList.contains('tmpl-cart')) window.location.reload();
      })
      .catch(function (err) { flash(btn, err.message || 'Sorry, try again', 2200); })
      .then(function () { btn.disabled = false; });
  });

  /* line quantity + remove on the cart page */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var line = b.getAttribute('data-line');
    var qty = b.getAttribute('data-line-change');
    b.disabled = true;
    fetch(routes.cart_change || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    }).then(function () { window.location.reload(); });
  });

  /* ---- collection sort --------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-sort]');
    if (!sel) return;
    var body = document.getElementById(sel.getAttribute('data-sort'));
    if (!body) return;
    // the Cleaners page sorts <tr> in a tbody, every other shop page sorts <li>
    // in a grid, so take whatever direct children the container has.
    var rows = Array.prototype.slice.call(body.children);
    var mode = sel.value;
    rows.sort(function (a, b) {
      if (mode === 'price-asc') return num(a, 'price') - num(b, 'price');
      if (mode === 'price-desc') return num(b, 'price') - num(a, 'price');
      if (mode === 'new') return num(b, 'new') - num(a, 'new');
      return num(a, 'i') - num(b, 'i');
    });
    rows.forEach(function (r) { body.appendChild(r); });
  });

  function num(row, key) { return parseFloat(row.getAttribute('data-' + key)) || 0; }

  /* ---- init -------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    var badge = $('#cart-badge');
    if (badge) paintBadge(parseInt(badge.textContent, 10) || 0);
  });
})();
